import React from 'react';
import { Link } from 'react-router-dom';
import Carousel from '../components/Carousel';
import GridTitle from '../components/GridTitle';
import FlexGrid from '../components/FlexGrid';
import '../styles/Home.css';
import '../styles/SoldOut.css';
import lot1 from '../assets/lot1.jpg';
import lot2 from '../assets/lot2.jpg';
import dummy1 from '../assets/dummy1.jpg';
import dummy2 from '../assets/dummy2.jpg';
import dummy3 from '../assets/dummy3.jpg';
import dummy4 from '../assets/dummy4.jpg';
import WhatsappCTA from '../components/WhatsappCTA';

const translations = {
  en: {
    hero: {
      title: "Land Lots for Sale",
      subtitle: "Find Your Perfect Beach Lot Today!",
      cta: "View Available Lots",
      financing: "Finance Your Fun! Buying your dream lot shouldn't be a headache! We've got breezy financing options"
    },
    gridTitle: {
      title: "Why Invest in Puerto Escondido?",
      subtitle: "Turn sand into gold: Puerto Escondido’s beachfront lots offer:",
      text: "8–12% rental yields and 20%+ annual appreciation. Secure your stake before prices surge!"
    },
    flexGrid: {
      mainSubtitle: "What is this!",
      box1: "Main Beaches and Map",
      box2: "Financing Options",
      box3: "Personalized Tours",
      box4: "Testimonials"
    },
    featured: {
      title: "Recently Added",
      lot1Title: "Piñuelos Residencial",
      lot1Desc: "Premium lots near Palmarito beach, in a rapidly developing area of Puerto Escondido.",
      lot2Title: "Playa Cangrejos",
      lot2Desc: "Second phase offers 33 new lots, following the successful sale of 40+ in phase one"
    },
    testimonials: {
      mainTitle: "What makes our offering unique? Discover the distinct advantages that set us apart.",
      ethicalTitle: "Ethical Development Practices",
      ethicalPoints: [
        "📍We only develop land with full consent from original landowners, ensuring fair agreements and mutual respect.",
        "📍Actively participate in agrarian assemblies to align our projects with community needs and traditions.",
        "📍\"Bienes Comunales\" Land is more affordable"
      ],
      communityTitle: "Deep Community Commitment",
      communityPoints: [
        "📍We’re embedded in the Oaxacan community and uphold long-term moral obligations—we don’t just build and leave.",
        "📍Maintain decade-long partnerships with agrarian communities, fostering trust and collaboration."
      ],
      strategicTitle: "Strategic & Sustainable Locations",
      strategicPoints: [
        "📍Select prime beachfront-adjacent zoning areas for optimal lifestyle and investment value.",
        "📍Prioritize ecological sustainability, minimizing environmental impact while delivering modern comforts."
      ],
      legalTitle: "Full Legal Compliance",
      legalPoints: [
        "📍All projects have valid permits, zoning clearances, and paperwork approved by local authorities.",
        "📍Strictly respect designated green areas and zoning laws, preserving natural and communal spaces."
      ],
      provenTitle: "Proven Track Record",
      provenPoints: [
        "📍Zero legal disputes across all developments—transparency and integrity are non-negotiable.",
        "📍Over 8 years of experience partnering with agrarian communities in Oaxaca."
      ],
      transparentTitle: "Transparent & Trustworthy",
      transparentPoints: [
        "📍Provide clarity and honesty about risks and rewards—no hidden agendas.",
        "📍Offer verified testimonials from satisfied clients who’ve successfully acquired land with us."
      ],
      visionTitle: "Local Roots, Global Vision",
      visionPoints: [
        "📍A family-owned Oaxacan business with deep regional ties, now expanding with diverse talent.",
        "📍Encourage buyers to ask locals about our reputation—we’re proud of our community standing."
      ],
      affordableTitle: "Affordable Luxury",
      affordablePoints: [
        "📍Premium lots include low-cost luxury amenities for elevated living without the high price tag.",
        "📍With 7+ large-scale projects (50+ lots each), we deliver proven quality at scale."
      ],
      empowering: "Empowering Buyers: Urge clients to ethically protect their investments—even if they don’t choose us. Our goal is to uplift responsible development on the Oaxacan coast.",
      learnLegal: "Learn more about this",
      learnTestimonials: "Learn more about this"
    }
  },
  es: {
    hero: {
      title: "Terrenos en Venta",
      subtitle: "¡Encuentra Tu Lote Perfecto Hoy!",
      cta: "Ver Lotes Disponibles",
      financing: "¡Financia Tu Sueño! Comprar tu lote ideal no debe ser complicado. Tenemos opciones de financiamiento flexibles"
    },
    gridTitle: {
      title: "¿Por Qué Invertir en Puerto Escondido?",
      subtitle: "Convierte arena en oro: Los terrenos frente al mar de Puerto Escondido ofrecen:",
      text: "Rendimientos de 8-12% y apreciación anual de 20%+. ¡Asegure su participación antes de que suban los precios!"
    },
    flexGrid: {
      mainSubtitle: "¿Qué es esto?",
      box1: "Playas Principales y Mapa",
      box2: "Opciones de Financiamiento",
      box3: "Tours Personalizados",
      box4: "Testimonios"
    },
    featured: {
      title: "Agregados Recientemente",
      lot1Title: "Piñuelos Residencial ",
      lot1Desc: "Lotes premium cerca de la playa Palmarito, en una zona en rápido desarrollo de Puerto Escondido.",
      lot2Title: "Playa Cangrejos",
      lot2Desc: "Segunda fase ofrece 33 nuevos lotes, luego de la exitosa venta de 40+ en la primera fase"
    },
    testimonials: {
      mainTitle: "¿Qué hace única nuestra oferta? Descubre las ventajas que nos distinguen.",
      ethicalTitle: "Prácticas de Desarrollo Ético",
      ethicalPoints: [
        "📍Solo desarrollamos terrenos con consentimiento total de los dueños originales, asegurando acuerdos justos y respeto mutuo.",
        "📍Participamos activamente en asambleas agrarias para alinear nuestros proyectos con las necesidades y tradiciones comunitarias.",
        "📍Los terrenos de \"Bienes Comunales\" son más accesibles"
      ],
      communityTitle: "Compromiso Comunitario Profundo",
      communityPoints: [
        "📍Estamos integrados en la comunidad oaxaqueña y mantenemos obligaciones morales a largo plazo—no solo construimos y nos vamos.",
        "📍Mantenemos asociaciones de décadas con comunidades agrarias, fomentando confianza y colaboración."
      ],
      strategicTitle: "Ubicaciones Estratégicas y Sostenibles",
      strategicPoints: [
        "📍Seleccionamos zonas privilegiadas cercanas a la playa para optimizar estilo de vida y valor de inversión.",
        "📍Priorizamos sostenibilidad ecológica, minimizando impacto ambiental mientras ofrecemos comodidades modernas."
      ],
      legalTitle: "Cumplimiento Legal Total",
      legalPoints: [
        "📍Todos los proyectos tienen permisos válidos, autorizaciones de zonificación y documentación aprobada por autoridades locales.",
        "📍Respetamos estrictamente áreas verdes y leyes de zonificación, preservando espacios naturales y comunales."
      ],
      provenTitle: "Historial Comprobado",
      provenPoints: [
        "📍Cero disputas legales en todos nuestros desarrollos—transparencia e integridad son no negociables.",
        "📍Más de 8 años de experiencia colaborando con comunidades agrarias en Oaxaca."
      ],
      transparentTitle: "Transparencia y Confiabilidad",
      transparentPoints: [
        "📍Brindamos claridad y honestidad sobre riesgos y beneficios—sin agendas ocultas.",
        "📍Ofrecemos testimonios verificados de clientes satisfechos que han adquirido terrenos con nosotros."
      ],
      visionTitle: "Raíces Locales, Visión Global",
      visionPoints: [
        "📍Empresa familiar oaxaqueña con profundos lazos regionales, ahora expandiéndose con talento diverso.",
        "📍Invitamos a compradores a preguntar a locales sobre nuestra reputación—estamos orgullosos de nuestro estatus comunitario."
      ],
      affordableTitle: "Lujo Accesible",
      affordablePoints: [
        "📍Lotes premium incluyen amenidades de lujo económicas para una vida elevada sin altos costos.",
        "📍Con 7+ proyectos a gran escala (50+ lotes cada uno), entregamos calidad comprobada en escala."
      ],
      empowering: "Empoderando Compradores: Instamos a clientes a proteger éticamente sus inversiones—incluso si no nos eligen. Nuestra meta es promover desarrollo responsable en la costa oaxaqueña.",
      learnLegal: "Aprende más sobre esto",
      learnTestimonials: "Aprende más sobre esto"
    }
  }
};

const Home = ({ language }) => {  // Receive language as prop from App
  return (
    <div className="home-page">
      {/* REMOVED the local language switcher div */}

      <section className="hero">
        <div className="hero-content">
          <h1>{translations[language].hero.title}</h1>
          <p>{translations[language].hero.subtitle}</p>
          <br />
          <Link to="/lots" className="cta-button">
            {translations[language].hero.cta}
          </Link>
          <br />
          <br />
          <p>{translations[language].hero.financing}</p>
        </div>
      </section>

      {/* Rest of the component remains EXACTLY THE SAME */}
      <Carousel 
        image1={dummy1} 
        image2={dummy2}
        image3={dummy3}
      />

      <GridTitle 
        title={translations[language].gridTitle.title}
        subtitle={translations[language].gridTitle.subtitle} 
        text={translations[language].gridTitle.text}
      />

      <FlexGrid 
        MainBoxImage={dummy4}
        MainBoxSubtitle={translations[language].flexGrid.mainSubtitle}
        SecondaryBoxTitle1={translations[language].flexGrid.box1}
        SecondaryBoxTitle2={translations[language].flexGrid.box2}
        SecondaryBoxTitle3={translations[language].flexGrid.box3}
        SecondaryBoxTitle4={translations[language].flexGrid.box4}
        language={language}
      />

      <section className="featured-lots">

        <h2>{translations[language].featured.title}</h2>
        <div className="lot-preview">

        <Link to="/pinuelos" style={{ textDecoration: 'none' }}>
          <div className="preview-card" >
            <img src={lot1} alt="Lot A" />
            <h3>{translations[language].featured.lot1Title}</h3>
            <p>{translations[language].featured.lot1Desc}</p>
          </div>
          </Link>

          <Link to="/cangrejos" style={{ textDecoration: 'none' }}>
          <div className="preview-card">            
            <img src={lot2} alt="Lot B" />
            <h3>{translations[language].featured.lot2Title}</h3>
            <p>{translations[language].featured.lot2Desc}</p>
          </div>
          </Link>

        </div>

        <WhatsappCTA language={language}/>
        
      </section>

      <div className="testimonial-text">
              <h1>{translations[language].testimonials.mainTitle}</h1>
      
              <h2>{translations[language].testimonials.ethicalTitle}</h2>
              {translations[language].testimonials.ethicalPoints.map((point, index) => (
                <p key={index}>{point}</p>
              ))}
              <Link to="/legal" className="cta-button">
                {translations[language].testimonials.learnLegal}
              </Link>
      
              <h2>{translations[language].testimonials.communityTitle}</h2>
              {translations[language].testimonials.communityPoints.map((point, index) => (
                <p key={index}>{point}</p>
              ))}
      
              <h2>{translations[language].testimonials.strategicTitle}</h2>
              {translations[language].testimonials.strategicPoints.map((point, index) => (
                <p key={index}>{point}</p>
              ))}
      
              <h2>{translations[language].testimonials.legalTitle}</h2>
              {translations[language].testimonials.legalPoints.map((point, index) => (
                <p key={index}>{point}</p>
              ))}
      
              <h2>{translations[language].testimonials.provenTitle}</h2>
              {translations[language].testimonials.provenPoints.map((point, index) => (
                <p key={index}>{point}</p>
              ))}
              <Link to="/testimonials" className="cta-button">
                {translations[language].testimonials.learnTestimonials}
              </Link>
      
              <h2>{translations[language].testimonials.transparentTitle}</h2>
              {translations[language].testimonials.transparentPoints.map((point, index) => (
                <p key={index}>{point}</p>
              ))}
      
              <h2>{translations[language].testimonials.visionTitle}</h2>
              {translations[language].testimonials.visionPoints.map((point, index) => (
                <p key={index}>{point}</p>
              ))}
      
              <h2>{translations[language].testimonials.affordableTitle}</h2>
              {translations[language].testimonials.affordablePoints.map((point, index) => (
                <p key={index}>{point}</p>
              ))}
      
              <p>{translations[language].testimonials.empowering}</p>
            </div>
    </div>
  );
};

export default Home;